export enum NameSpace {
    APP = 'gigacube',
}

export enum ActionType {
    INIT_STORE = 'gigacube/initStore',
    SET_SALESCHANNEL = 'gigacube/setSalesChannel',
    GET_TARIFF_SUCCESS = 'gigacube/getTariffSuccess',
    SET_ERROR = 'gigacube/setError',
    SELECT_OPTION = 'gigacube/selectOption',
    TRACK_ERROR = 'gigacube/trackError',
};

export enum HtmlId {
    HARDWARE_PICKER = 'gigacube-hardware-picker-container',
    HIGHLIGHT_BADGE = 'gigacube-highlight-badge',
    QUALITY_SEAL = 'gigacube-quality-seal',
    GIGACUBE_CONTAINER = 'gigacube-container',
    ERROR_CONTAINER = 'gigacube-notification-container',
    ERROR_NOTIFICATION = 'gigacube-notification',
    TARIFF_SELECTION = 'gigacube-tariff-option-tabs-container',
    TARIFF_BENEFITS = 'gigacube-tariff-benefits',
    FLEX_HINT = 'gigacube-flex-hint-text',
    HARDWARE_HINT = 'gigacube-hardware-info-text',
    YOUNG_HINT = 'gigacube-young-hint-text',
    COVERAGE_MAP = 'button-netzabdeckung'
}
